import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

/**
 * 渲染兜底：任何子组件抛错都只影响自己那一块，不再让整页白屏。
 *
 * 背景：board #153 曾因为国家列渲染时 `Intl.DisplayNames.of()` 抛 RangeError，
 * 导致 React 把整棵树卸掉、页面纯黑。这里把影响范围收敛到最小。
 */
export default class ErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode; label?: string },
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // 开发时方便定位；生产上至少留一条日志
    console.error('[render-error]', this.props.label ?? '', error, info.componentStack)
  }

  render() {
    if (this.state.error !== null) {
      if (this.props.fallback !== undefined) return this.props.fallback
      return (
        <span className="render-error" title={this.state.error.message}>
          渲染失败
        </span>
      )
    }
    return this.props.children
  }
}
